import { defineMessages } from 'react-intl';

export default defineMessages({
  dragText: {
    id: 'CompanyScreen.CompanyReports.UploadButton',
    defaultMessage: 'Drag & Drop',
  },
});
